export const ARQUIVOS_PERMITIDOS = [
    'application/pdf', 
    'image/jpeg', 
    'image/png', 
    'application/zip', 
    'application/zip', 
    'application/octet-stream', 
    'application/x-zip-compressed', 
    'multipart/x-zip', 
    'audio/m4a',
    'audio/mp4',
    'audio/x-m4a',
    'audio/mpeg', 
    'video/mp4'
];
